import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFoundPage() {
    return (
        <div className="min-h-screen bg-[#0a0a1a] flex items-center justify-center p-4">
            <div className="text-center max-w-md">
                <div className="mb-6">
                    <span className="text-7xl font-black bg-gradient-to-r from-[#681793] to-[#FF914D] bg-clip-text text-transparent">
                        404
                    </span>
                </div>
                <h1 className="text-2xl font-bold text-white mb-3">Page introuvable</h1>
                <p className="text-muted-foreground mb-8">
                    La page que vous cherchez n'existe pas ou a été déplacée.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Link to="/">
                        <Button className="bg-gradient-to-r from-[#681793] to-[#FF914D] text-white">
                            <Home className="w-4 h-4 mr-2" />
                            Accueil
                        </Button>
                    </Link>
                    <Button variant="outline" className="border-white/10 text-white" onClick={() => window.history.back()}>
                        <ArrowLeft className="w-4 h-4 mr-2" />
                        Retour
                    </Button>
                </div>
            </div>
        </div>
    );
}
